import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnException,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { getCategoryById } from "@insite/client-framework/Services/CategoryService";
import { CategoryModel } from "@insite/client-framework/Types/ApiModels";
import {
    CategoryDataModel,
    fetchCategoriesData,
    GetCategoriesApiParameter,
    GetCategoryByIdApiParameter,
} from "@tCentro/Services/CategoryServiceExtension";

type HandlerType = ApiHandlerDiscreteParameter<GetCategoriesApiParameter, CategoryModel>;

export const DispatchBeginLoadCategories: HandlerType = props => {
    (props as unknown as any).dispatch({
        type: "Custom/SiteMap/BeginLoadCategoryDataModel",
    });
};

export const LoadCategoriesForSiteMap: HandlerType = async props => {
    (props as unknown as any).apiResult = await fetchCategoriesData();
};

export const DispatchCompleteLoadProductchoices: HandlerType = props => {
    (props as unknown as any).dispatch({
        type: "Custom/SiteMap/CompleteLoadCategoryDataModel",
        result: props.apiResult,
    });
};

export const chain = [DispatchBeginLoadCategories, LoadCategoriesForSiteMap, DispatchCompleteLoadProductchoices];

const categoryHandler = createHandlerChainRunner(chain, "CENSiteMapCategoryHandler");
export default categoryHandler;
